// Omnix/common/schemas/collections/omniAudiences.js
import { z } from "zod";

const AudienceRuleSchema = z.object({
    id: z.string().uuid().describe("Unique ID for the rule row."),
    field: z.enum(['tags', 'email', 'company', 'firstName', 'lastName']).describe("The contact field to filter on."),
    operator: z.enum(['contains', 'not_contains', 'equals', 'not_equals', 'startsWith', 'endsWith']).describe("The comparison operator."),
    value: z.string().min(1, "Value cannot be empty.").describe("The value to compare against."),
});

const OmniAudienceSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().optional().describe("The subscription this audience belongs to."),
    
    name: z.string().min(1, "Audience name is required."),
    description: z.string().optional().nullable(),
    
    rules: z.array(AudienceRuleSchema).default([]).describe("An array of rules that define the audience segment."),
    
    // Timestamps
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default OmniAudienceSchema;